import { useLocation, Link, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from '../components/Navbar';
import './OrderSuccess.css';

export default function OrderSuccess() {
  const location = useLocation();
  const navigate = useNavigate();

  const orderId = location.state?.orderId;
  const email = location.state?.email;
  const totalAmount = location.state?.totalAmount;

  /* ─── Redirect if accessed directly without state ─── */
  useEffect(() => {
    if (!orderId) {
      navigate('/', { replace: true });
    }
  }, [orderId, navigate]);

  if (!orderId) return null;

  return (
    <>
      <Navbar />
      <div className="os-page">
        <div className="os-card">

          {/* Big Green Tick */}
          <div className="os-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <path d="m5 12.6 4.5 4.4L19 7" />
            </svg>
          </div>

          <h1 className="os-title">Order Placed Successfully!</h1>
          <p className="os-subtitle">
            Thank you for shopping with VKTrend 🎉
          </p>

          {/* Order ID + Amount */}
          <div className="os-info">
            <div className="os-info-row">
              <span className="os-info-label">Order ID</span>
              <span className="os-info-value">#{orderId}</span>
            </div>
            {totalAmount && (
              <div className="os-info-row">
                <span className="os-info-label">Total Paid</span>
                <span className="os-info-value os-info-amount">
                  ₹{Number(totalAmount).toLocaleString('en-IN')}
                </span>
              </div>
            )}
          </div>

          {/* Email Confirmation */}
          {email && (
            <div className="os-email">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
                <rect x="2" y="4" width="20" height="16" rx="2" />
                <path d="m22 6-10 7L2 6" />
              </svg>
              <div>
                <p className="os-email-title">Confirmation email sent</p>
                <p className="os-email-addr">{email}</p>
              </div>
            </div>
          )}

          {/* Estimated delivery hint */}
          <p className="os-hint">
            Your order will be delivered within 3–5 business days.
          </p>

          {/* Actions */}
          <div className="os-actions">
            <Link to="/profile" className="os-btn os-btn-primary">
              View My Orders
            </Link>
            <Link to="/shop" className="os-btn os-btn-secondary">
              Continue Shopping
            </Link>
          </div>

        </div>
      </div>
    </>
  );
}